import React from 'react';
import { useSelector } from 'react-redux';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import SimpleProductDetailPlugin from './SimpleProductDetailPlugin';
import PrinterDetailPlugin from './PrinterDetailPlugin';
import PackageConfigurator from './package-configurator/PackageConfigurator';

const pdpSkus = ['PKG-F3-WSVC-BASIC', 'PKG-F3L-BASIC', 'PKG-F3BL-BASIC'];

const configuratorV2 = ['PKG-FS1-120V', 'PKG-FS1-230V'];

const ProductDetailPlugin = props => {
  const { sku } = props;
  const { storeId } = useSelector(state => ({
    storeId: state.store.id
  }));

  if (pdpSkus.includes(sku)) {
    return <PrinterDetailPlugin {...props} />;
  }

  if (configuratorV2.includes(sku)) {
    // Use storeId as key to force remount of whole component to reset pending fetch ops when store id changes. The store id is defaulting to us_en, so every first request from a different id will cause a re-render.
    return <PackageConfigurator key={storeId} {...props} storeId={storeId} />;
  }

  return <SimpleProductDetailPlugin {...props} />;
};

export default DisplayComponent(ProductDetailPlugin);
